import Header from "../../components/Header/Header";
import Navbar from "../../components/Navbar/Navbar";
import './AllBooks.css'

function AllBooks() {
    return (
        <div>
            <Header />
            <Navbar />
        </div>
    )   
}

export default AllBooks;